/**
 * Live TV: native device share for the Currently on Air card.
 * The card is re-rendered by live-tv-currently-on-air-updater.js, so the click handler is delegated
 * and the button's visibility is re-checked whenever the slot changes.
 * Title and text come from the button's data attributes (locale keys live_tv.share_title / share_text).
 */
(function () {
  'use strict';

  var SELECTOR = '[data-ltv-share]';
  if (typeof navigator.share !== 'function') return;

  function reveal(root) {
    var buttons = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < buttons.length; i++) buttons[i].hidden = false;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest(SELECTOR);
    if (!button) return;
    navigator
      .share({
        title: button.getAttribute('data-share-title') || '',
        text: button.getAttribute('data-share-text') || '',
      })
      .catch(function (err) {
        // AbortError = shopper closed the share sheet; not a failure.
        if (err && err.name !== 'AbortError') console.warn('[LTV share]', err);
      });
  });

  reveal();
  new MutationObserver(function () {
    reveal();
  }).observe(document.body, { childList: true, subtree: true });
})();
